import axios from "../../lib/axios";
import { toast } from "react-toastify";

const TRADE_API = process.env.REACT_APP_TRADE_API;
const IMPORT_TRADE_API = process.env.REACT_APP_IMPORT_TRADE_API;
const DELETE_TRADE_API = process.env.REACT_APP_DELETE_TRADE_API;

const manualTrade = async (trade) => {
  const response = await axios.post(TRADE_API, trade);
  if (response && response.data) {
    response.data.error
      ? toast.error(response.data.error)
      : toast.success(response.data.success);
  }
  return response;
};
const importTrade = async (trade) => {
  const response = await axios.post(IMPORT_TRADE_API, trade);
  if (response && response.data) {
    response.data.error
      ? toast.error(response.data.error)
      : toast.success(response.data.success);
  }
  return response;
};
const fetchTrade = async (pg, acc) => {
  const params = {
    params: {
      pg: pg,
      accId: acc,
    },
  };
  const response = await axios.get(TRADE_API, params);
  if (response && response.data) {
    response.data.error
      ? toast.error(response.data.error)
      : toast.success(response.data.success);
  }
  return response;
};
const deleteTrade = async (payload) => {
  if (!payload) return;
  const response = await axios.delete(DELETE_TRADE_API, { data: payload });
  if (response && response.data) {
    response.data.error
      ? toast.error(response.data.error)
      : toast.success(response.data.success);
  }
  return response;
};
const tradeApi = {
  manualTrade: manualTrade,
  importTrade: importTrade,
  fetchTrade: fetchTrade,
  deleteTrade: deleteTrade,
};

export default tradeApi;
